import { Stack } from "@mui/material";
import BrandNameSearch from "../BrandNameSearch";
import NeedsConfigurationFilterItems from "./NeedsConfigurationFilterItems";

interface Props {
  rows: any[];
  brandNameQuery: string;
  setBrandNameQuery: (value: string) => void;
  selectedAffiliateSystem: string[] | null;
  setSelectedAffiliateSystem: (value: string[] | null) => void;
  selectedCompany: string[] | null;
  setSelectedCompany: (value: string[] | null) => void;
  selectedWebsite: string[] | null;
  setSelectedWebsite: (value: string[] | null) => void;
  selectedStuckAt: string[] | null;
  setSelectedStuckAt: (value: string[] | null) => void;
  selectedReason: string[] | null;
  setSelectedReason: (value: string[] | null) => void;
  clearFilters: () => void;
}

// Plain name search per spec (no multi-select popup — that's All Brands
// only). No primary action button on this tab (no bulk run/connect), per spec.
const NeedsConfigurationFilterCard = ({
  rows,
  brandNameQuery,
  setBrandNameQuery,
  ...filterProps
}: Props) => {
  return (
    <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap" sx={{ width: "100%" }}>
      <BrandNameSearch rows={rows} value={brandNameQuery} onChange={setBrandNameQuery} />
      <NeedsConfigurationFilterItems rows={rows} {...filterProps} />
    </Stack>
  );
};

export default NeedsConfigurationFilterCard;
